export const ACTION_TRANSFER = "transfer";
export const ACTION_RECALL = "recall";
export const APP_STATUS_INPROGRESS = ["inprogress", "eligrecv"];
export const ROLE_BROKER = "BROKER";
export const ROLE_ASSISTANT = "ASSISTANT"
export const TYPE_OWNER = "OWNER";
export const TYPE_REVIEWER = "REVIEWER"
export const USER_TYPE_HPA = "HPA";
export const ACTION_TRANSFER_TO_PRIMARY = "transfertoprimary";
export const ACTION_DELETE = "delete";
export const USER_TYPE_APPASSISTOR = "APPASSISTOR";
export const ACTION_EDIT_OWNERSHIP = "editOwnerShip";
export const GENERAL_AGENCY = 'GENERAL AGENCY';
export const PRIMARY = "PRIMARY";
export const TOOLTIP_APPLICATIONS_STATUSES = ["new", "inevalution", "addinforeqd", "qenotvalid", "ineligible", "submitreject"];
// we interpret new, inevaliuation and ineligible as "Pending Validation" on UI. 
//This may need change later. Adding this config for enabling transfer and recall for now.
//waiting on confirmation on Continue On FFM,Payment Failed statuses to be added to SE
//inprogress apps are not SE status.
export const SE_APPLICATION_STATUSES = ["new", "inevalution", "addinforeqd", "qenotvalid"];
export const ROLE_CONSUMER = "CONSUMER";
export const ROLE_AGENT = "AGENT";
export const DELEGATE = "DELEGATE";

export const MARKET_CONFIG = {
    smallgroup: 'Small Group',
    largegroup: 'Large Group',
    individual: 'Individual',
    senior: 'Senior'
}


